import { useState } from 'react';
import { PrivacyPolicyDialog } from '@/features/auth/components/PrivacyPolicyDialog';
import { TermsOfServiceDialog } from '@/features/auth/components/TermsOfServiceDialog';

/** Support inbox behind "Contact us" on every auth surface (DEF-248). */
const SUPPORT_MAILTO = 'mailto:support@truspace.com';

const LINK_CLASS =
  'rounded-sm transition-colors hover:text-sidebar-text-active hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-accent focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar-bg';

/**
 * Contact / Privacy / Terms rail for the auth brand panel.
 *
 * Owns the two policy dialogs so every pre-login page gets the same legal
 * surface from the shared shell — no page has to wire the modals itself.
 * The policies are modals rather than routes because they are also reachable
 * mid-registration, where navigating away would drop the form.
 */
export function AuthLegalLinks() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  function handleOpenPrivacy() {
    setPrivacyOpen(true);
  }

  function handleOpenTerms() {
    setTermsOpen(true);
  }

  return (
    <>
      <nav
        aria-label="Legal and support"
        className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-sidebar-text"
      >
        <a href={SUPPORT_MAILTO} className={LINK_CLASS}>
          Contact us
        </a>
        <button type="button" onClick={handleOpenPrivacy} className={LINK_CLASS}>
          Privacy Policy
        </button>
        <button type="button" onClick={handleOpenTerms} className={LINK_CLASS}>
          Terms of Service
        </button>
      </nav>

      <PrivacyPolicyDialog open={privacyOpen} onOpenChange={setPrivacyOpen} />
      <TermsOfServiceDialog open={termsOpen} onOpenChange={setTermsOpen} />
    </>
  );
}
